<template>
    <div :class="alertClass">
        <div>
            <i v-if="showIcon"
               :class="iconClass"></i>&nbsp;{{ text }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
import UserFacingError from '@/libraries/DigiTickets/Errors/UserFacingError';

/**
 * This component displays an error message to the user.
 *
 * It accepts one of the following as the error prop:
 * - A string, which will be displayed as-is.
 * - An Error object, which will display the message property.
 * - A UserFacingError, which will show its translated langKey if present, or the message property.
 */
export default {
    name: 'ErrorMessage',

    props: {
        /**
         * @type {String|Error|UserFacingError}
         */
        error: {
            type: [String, Object],
            required: true,
        },

        showIcon: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        text() {
            if (typeof this.error === 'string') {
                return this.error;
            }

            return this.error.langKey ? this.l(this.error.langKey) : this.error.message;
        },

        color() {
            if (this.error instanceof UserFacingError) {
                return this.error.getCssClass();
            }

            return 'danger';
        },

        alertClass() {
            return `alert alert-${this.color}`;
        },

        iconClass() {
            switch (this.color) {
                case 'info':
                    return 'fa-solid fa-info-circle';
                case 'warning':
                    return 'fa-solid fa-circle-exclamation';
                default:
                    return 'fa-solid fa-triangle-exclamation';
            }
        },
    },
};
</script>
